export default "__VITE_ASSET__CwkaNgau__"